module.exports = __webpack_public_path__ + "static/media/jewelry-box-black.c1c418fe.png";